import { IBillingInfo } from "@/types";
import billingDefault from "@/data/billingDefault";

export interface BillingState {
  billing: {} | IBillingInfo;
}
export default {
  namespaced: true,
  state: {
    billing: billingDefault
  } as BillingState,
  getters: {
    getBilling: (state: BillingState) => state.billing
  },
  mutations: {
    SET_BILLING(state: BillingState, newBilling: IBillingInfo) {
      state.billing = newBilling;
    }
  }
};
